<template>
	<div class="app flex-row align-items-center">
        <LiveDigi v-if="sportProvider == 0"></LiveDigi>
        <LiveMaintenance v-if="sportProvider == 3"></LiveMaintenance>
        <LiveBetco  v-if="sportProvider == 1"></LiveBetco>
	</div>
</template>
<script>
    import LiveDigi from './Sportsbook/Digitain/Live.vue'
    import LiveBetco from './Sportsbook/Betco/Live.vue'
    import LiveMaintenance from './Sportsbook/SportMaintenance.vue'
    export default {
        name: 'Live',
        metaInfo () {
            return {
                meta: [
                { 'http-equiv':'Content-Security-Policy', content: "upgrade-insecure-requests" },
                ]
            }
        },
        components:{
            LiveDigi,
            LiveBetco,
            LiveMaintenance,
        },      
        computed:{
            sportProvider(){
                return this.$store.getters['auth/user_detail'].detail.sport_provider;
            }
        },  
        data: function() {
            return {
                loading: false,
            }
        },
    }
</script>